import { TemplatePage } from './types';

const birthdayPage: TemplatePage = {
  header: {
    color: '#BFD7D9',
    icon: 'images/video-templates/birthday.jpg',
    title: 'Happy Birthday Video Templates ',
    title_meta: 'Free & Editable Happy Birthday Video Templates',
    description_meta:
      'Delight your friends, teammates and customers with personalized video greetings. Get 50+ happy birthday video ' +
      'templates to express your best wishes.',
    description:
      'Make someone’s birthday brighter by sharing an amusing video. Check out a collection of Wave.video’s happy ' +
      'birthday video templates to create outstanding online greeting cards.'
  },
  footer: {
    category: 'Happy Birthday',
    description:
      'With Wave.video, you don’t have to be a professional videographer or motion designer. This powerful online ' +
      'video editor provides its users with a great variety of stylish and easily customizable video templates. In a ' +
      'matter of minutes, you can adjust any template to your certain use case by changing colors, fonts, texts and ' +
      'other elements. All templates come in the most popular formats so that you can replicate your video content ' +
      'for different channels and platforms.'
  },
  content: [
    {
      type: 'templates',
      title: 'Happy Birthday Videos',
      search: { name: 'birthday' }
    },
    {
      type: 'stocks',
      title: 'happy birthday',
      search: { name: 'birthday' }
    },
    { type: 'calendar' }
  ]
};

export default birthdayPage;
